import { useEffect, useState } from "react";

type ContentMap = Record<string, string>;

const DEFAULTS: ContentMap = {
  hero_title: "Expert Appliance Repair at Your Doorstep",
  hero_subtitle: "AC, Washing Machine, RO & Fridge repair by trusted technicians in Mansa. Same-day service guaranteed.",
  hero_cta: "Book a Service",
  brand_tagline: "Sardar Ji Ki Apni Dukaan",
  shop_name: "Gurpreet Refrigeration",
  shop_address: "Lalluana Road, Mansa, Punjab",
  shop_phone: "8968170459",
  shop_email: "gs5472596@gmail.com",
  shop_hours: "Mon - Sun: 9:00 AM - 9:00 PM",
  why_title: "Why Choose Us",
  why_1_title: "Same Day Service",
  why_1_desc: "Book today, fixed today. Fast response across Mansa.",
  why_2_title: "Expert Technicians",
  why_2_desc: "Years of experience repairing every major brand.",
  why_3_title: "Affordable Rates",
  why_3_desc: "Honest pricing. No hidden charges. Upfront quotes.",
  hero_badge_1: "Same day service",
  hero_badge_2: "90-day warranty",
  hero_badge_3: "500+ happy customers",
  book_eyebrow: "Book a service",
  book_title: "Tell us about your problem, we'll call you back",
  book_subtitle: "Fill the form and we'll reach you in minutes. Or call us directly.",
  book_perks_title: "Why book with us?",
  book_perk_1: "Free visit on repairs above ₹500",
  book_perk_2: "Genuine spare parts only",
  book_perk_3: "90-day service warranty",
  whatsapp_number: "8968170459",
  footer_about: "Professional home appliance repair in Mansa. AC, Washing Machine, RO & Fridge specialists.",
  logo_url: "https://ivedfrlmvdxozmccxwnd.supabase.co/storage/v1/object/public/site-images/logo_url/1777430818199-hvchuy.jpeg",
  hero_image_url: "https://ivedfrlmvdxozmccxwnd.supabase.co/storage/v1/object/public/site-images/hero_image_url/1777430873539-zourby.jpeg",
  gallery_title: "Our Work",
  gallery_subtitle: "Recent repairs by our team",
  testimonials_title: "What our customers say",
  testimonials_subtitle: "Trusted by 500+ happy families in Mansa",
  nav_links: "Services|#services,Why Us|#why,Gallery|#gallery,Reviews|#testimonials,Book|#book,Contact|#contact",
};

export function parseNavLinks(raw: string): { label: string; href: string }[] {
  if (!raw) return [];
  return raw.split(",").map((s) => {
    const [label, href] = s.split("|").map((x) => x.trim());
    return { label: label || "", href: href || "#" };
  }).filter((l) => l.label);
}

const CACHE_KEY = "site_content_cache_v1";
let sharedContent: ContentMap | null = null;
let sharedPromise: Promise<ContentMap> | null = null;

function loadCache(): ContentMap | null {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function useSiteContent() {
  // Use cached content from last fetch on first render — this prevents the
  // "defaults flash then update" issue after admin edits.
  const [content, setContent] = useState<ContentMap>(() => {
    if (sharedContent) return sharedContent;
    const cached = loadCache();
    return cached ? { ...DEFAULTS, ...cached } : DEFAULTS;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    if (sharedContent) {
      setContent(sharedContent);
      setLoading(false);
      return () => { alive = false; };
    }

    sharedPromise ||= import("@/integrations/supabase/client").then(({ supabase }) =>
      supabase.from("site_content").select("key,value").then(({ data }) => {
      const map: ContentMap = { ...DEFAULTS };
      const fresh: ContentMap = {};
      if (data) {
        data.forEach((r) => {
          map[r.key] = r.value;
          fresh[r.key] = r.value;
        });
        try { localStorage.setItem(CACHE_KEY, JSON.stringify(fresh)); } catch {}
      }
      sharedContent = map;
      return map;
    }));

    sharedPromise.then((map) => {
      if (!alive) return;
      setContent(map);
      setLoading(false);
    });

    return () => { alive = false; };
  }, []);

  return { content, loading };
}
